import React, { useEffect, useState, useRef } from "react";
import { useLazyQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import moment from "moment";
import { RESOURCES_QUERY } from '../../utils/queries'
import CharlesClough from '../../assets/images/team/charles.jpg'
import downloadIcon from '../../assets/images/download_icon.svg'
import docLinkIcon from '../../assets/images/doclink_icon.svg'
import UseIsInViewport from '../../utils/useInViewPort'

function LongShortFund(props) {
    const { ref1, ref2, ref3, ref4, ref5, activeTab, documentData } = props
    const CLASS_I = 'class_1'
    const CLASS_INV = 'class_inv'
    const CLASS_A = 'class_a'
    const CLASS_C = 'class_c'
    const ANNUALIZED = 'annualized'
    const CUMULATIVE = 'cumulative'
    const CALENDAR_YEAR = 'calendar_year'
    const TOP_10_HOLDINGS = 'top_10_holdings'
    const ALL_HOLDINGS = 'all_holdings'
    const CURRENT_YEAR = 'current_year'
    const PREVIOUS_YEAR = 'previous_year'
    const [currentList, setCurrentList] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [activeClass, setActiveClass] = useState(CLASS_I);
    const [activePerformance, setActivePerformance] = useState(ANNUALIZED);
    const [activeHoldings, setActiveHoldings] = useState(TOP_10_HOLDINGS)
    const [activeDistribution, setActiveDistribution] = useState(CURRENT_YEAR)
    const [
        fetchResources,
        { data: resourceData, loading: resourceLoading, error: resourceError },
    ] = useLazyQuery(RESOURCES_QUERY);

    useEffect(() => {
        fetchResources({ variables: { ticker: 'GLS', documentType: documentData, documentTypes: documentData } });
    }, [documentData])

    const getUniqueFunds = (data) => {
        let sortArray = [...new Set(data?.flat().sort((a, b) => b['createdAt']?.toString().localeCompare(a['createdAt']?.toString())).map(item => item))]
        const uniqueIds = [];
        const uniqueArray = sortArray.filter(element => {
            const isDuplicate = uniqueIds.includes(element['friendlyName']);
            if (!isDuplicate) {
                uniqueIds.push(element['friendlyName']);

                return true;
            }
            return false;
        });
        return uniqueArray
    }
    
    useEffect(() => {
        let completeFund = resourceData?.resources?.completeFundData
        let currentUpdates = []
        let regulatoryUpdates = []
        completeFund?.length > 0 && completeFund?.map((data) => {
            if ((data?.type == 'monthly_factsheet' || data?.type == 'monthly-factsheet') && data?.funds?.length > 0) {
                currentUpdates?.push(data?.funds)
            }
            if ((data?.type == 'semi_annual_report' || data?.type == 'semi-annual-report') && data?.funds?.length > 0) {
                regulatoryUpdates.push(data?.funds)
            }
            if ((data?.type == 'annual_report' || data?.type == 'annual-report') && data?.funds?.length > 0) {
                regulatoryUpdates.push(data?.funds)
            }
            if ((data?.type == 'regulatory') && data?.funds?.length > 0) {
                regulatoryUpdates.push(data?.funds)
            }
            if ((data?.type == 'prospectus_supplement' || data?.type == 'prospectus-supplement') && data?.funds?.length > 0) {
                regulatoryUpdates.push(data?.funds)
            }
            if ((data?.type == 'prospectus') && data?.funds?.length > 0) {
                regulatoryUpdates.push(data?.funds)
            }
        })
        setCurrentList(getUniqueFunds(currentUpdates))
        setReportList(getUniqueFunds(regulatoryUpdates))
    }, [resourceData])

    useEffect(() => {
        if (activeTab) {
            if (activeTab == ANNUALIZED || activeTab == CUMULATIVE || activeTab == CALENDAR_YEAR) {
                setActivePerformance(activeTab)
            } else if (activeTab == TOP_10_HOLDINGS || activeTab == ALL_HOLDINGS) {
                setActiveHoldings(activeTab)
            } else if (activeTab == CURRENT_YEAR || activeTab == PREVIOUS_YEAR) {
                setActiveDistribution(activeTab)
            } else if (activeTab == CLASS_I || activeTab == CLASS_INV || activeTab == CLASS_A || activeTab == CLASS_C) {
                setActiveClass(activeTab)
            }
        }
    }, [activeTab])

    return (
        <>

            <div class="container inner-content--callout video-element">

                <div id="fund_details" class="waypoint__subnav" ref={ref1}></div>

                <h3>Fund Details</h3>

                <h3 class="mod1">Objective</h3><br />
                <br />
                <p>The Fund seeks to provide investors with long-term capital appreciation.</p>

                <h3 class="mod1">Portfolio Construction</h3>
                <br />
                <p>
                </p><ul>
                    <li class="indent"><strong>Global Market View</strong>: The Adviser has the ability to adjust net exposure to reflect their global market views enabling the Fund’s net equity exposure to range between 20-80%.</li>
                    <li class="indent"><strong>Security Selection</strong>: The Adviser’s selection process identifies profit cycles and seeks disruptors to businesses through a global perspective.</li>
                    <li class="indent"><strong>Hedging</strong>: The Adviser’s flexible approach may include short positions, exchange traded funds, options &amp; futures, as well as exposure to fixed income securities.</li>
                </ul>
                <p></p>

            </div>


            <div class="container">

                <div class="col span_3_of_6">

                    <h3 class="mod1">Fund Management</h3><br />
                    <br />
                </div>
            </div>

            <div class="container">

                <div id="bioTarget"><div class="row"><p class="bio_p">
                    <img src={CharlesClough} alt="Charles I. Clough, Jr., CFA<sup>1</sup>" />
                    <b>Charles I. Clough, Jr., CFA<sup>1</sup></b>
                    <br />Chairman, Co-CIO, Partner &amp; Portfolio Manager: Clough Closed-End Funds &amp; Clough Global Long/Short Fund<br />
                    <br />Chuck Clough is the Chairman and Co-Chief Investment Officer of Clough Capital. He has been active in the securities and investment business for over 56 years.<br />
                    <br />Prior to founding Clough Capital, Chuck served as the Chief Global Investment Strategist from 1987 through 1999 at Merrill Lynch &amp; Co., Inc. During this time, he advised many of the world's top institutions and investors on portfolio strategy.<br />
                    <br />Prior to his tenure at Merrill Lynch, Chuck was Director of Investment Policy and Chief Strategist at Cowen &amp; Co. Previously, he served as the Director of Research and a Portfolio Manager at the Boston Company, a Portfolio Manager at Colonial Management Associates and a Vice President and Senior Research Analyst for both Donaldson, Lufkin &amp; Jenrette and Alliance Capital Management Company. Chuck serves on the boards of a number of hospitals, as well as educational and charitable institutions, including his alma mater, Boston College. Chuck graduated magna cum laude with a major in History and a minor in Economics from Boston College and earned an MBA at the University of Chicago. He has been a CFA<sup>®</sup> charterholder since 1979. Chuck is an ordained permanent deacon in the Roman Catholic Archdiocese of Boston and serves in that capacity at his local parish in Concord, MA.<br />
                    <br /></p><div class="disclosure"><sup>1</sup>The CFA charter is a qualification for finance and investment professionals, particularly in the fields of investment management and financial analysis of stocks, bonds and their derivative assets. The program focuses on portfolio management and financial analysis, and provides a generalist knowledge of other areas of finance. It is a graduate level self study program offered by the CFA Institute (formerly AIMR) to investment and financial professionals. A candidate who successfully completes the program and meets other professional requirements is awarded a "CFA charter" and becomes a "CFA charterholder".<br />
                        <br />
                        {/* <sup>2</sup>In polling for the 'All-America Research Team', Institutional Investor sent questionnaires covering several categories and investment sectors to research directors and the chief investment officers of major money management firms. In addition, they contacted institutional investors from client lists submitted by Wall Street research directors and sent questionnaires to analysts and portfolio managers at many top institutions. Rankings were determined strictly by using numerical scores. The number of votes awarded to each analyst were weighted based on the size of the institution responding and the place (first, second, third, or fourth) it awarded to that analyst. */}
                    </div><p></p></div></div>

            </div>


            <div class="container">
                <div className="spacer" />
            </div>


            <div class="container">


                <div class="tabs" id="tabs__daily-data">

                    <ul class="tabs__list">
                        <li class="tabs__list-item">
                            <a class={`tabs__tab ${activeClass == CLASS_I ? 'active' : ''}`} onClick={() => setActiveClass(CLASS_I)}>Class I</a>
                        </li>
                        <li class="tabs__list-item">
                            <a class={`tabs__tab ${activeClass == CLASS_INV ? 'active' : ''}`} onClick={() => setActiveClass(CLASS_INV)}>Class Inv</a>
                        </li>
                        <li class="tabs__list-item">
                            <a class={`tabs__tab ${activeClass == CLASS_A ? 'active' : ''}`} onClick={() => setActiveClass(CLASS_A)}>Class A</a>
                        </li>
                        <li class="tabs__list-item">
                            <a class={`tabs__tab ${activeClass == CLASS_C ? 'active' : ''}`} onClick={() => setActiveClass(CLASS_C)}>Class C</a>
                        </li>
                    </ul>


                    {activeClass == CLASS_I &&
                        <div class="tabs__tab-content" style={{ display: "block" }}>

                            <div id="dailyDataTableWrapper1" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>


                                <h3 class="mod1">Daily Data</h3>&nbsp;
                                <date>as of <span>04/11/2023</span></date>

                                <table class="table--mod-2">

                                    <tbody><tr>
                                        <td>Ticker:<span>CLOIX</span></td>
                                        <td></td>
                                        <td>NAV:<span>$9.12</span></td>
                                    </tr>
                                        <tr>
                                            <td>CUSIP:<span>18914W304</span></td>
                                            <td></td>
                                            <td>NAV Change:<span>$0.00</span></td>
                                        </tr>
                                        <tr>
                                            <td>Inception Date:<span>09/30/2015</span></td>
                                            <td></td>
                                            <td>Market Price:<span>$9.12</span></td>
                                        </tr>

                                        <tr>
                                            <td class="noborder"></td>
                                            <td></td>
                                            <td>Total Net Assets:<span>$26,468,597.75</span></td>
                                        </tr>

                                    </tbody></table>

                                <h3 class="mod1">Expenses</h3>&nbsp;
                                <date>as of <span>02/28/2023</span></date>

                                <table class="table--mod-2">

                                    <tbody><tr>
                                        <td>Direct Operating Expenses:<span>2.59%</span></td>
                                        <td></td>
                                        <td>Total Net Expense Ratio<sup>†</sup>:<span>1.54%</span></td>
                                    </tr>
                                        <tr>
                                            <td>Total Expense Ratio:<span>2.61%</span></td>
                                            <td></td>
                                            <td class="noborder"></td>
                                        </tr>

                                    </tbody></table>

                            </div>

                            <div id="dailyDataTableIndicator1" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>

                        </div>
                    }
                    {activeClass == CLASS_INV &&
                        <div class="tabs__tab-content" style={{ display: "block" }}>

                            <div id="dailyDataTableWrapper2" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>

                                <h3 class="mod1">Daily Data</h3>&nbsp;
                                <date>as of <span id="daily_asofdate_inv">04/11/2023</span></date>

                                <table class="table--mod-2">

                                    <tbody><tr>
                                        <td>Ticker:<span>CLOAX</span></td>
                                        <td></td>
                                        <td>Net Asset Value (NAV):<span>$8.95</span></td>
                                    </tr>
                                        <tr>
                                            <td>CUSIP:<span>18914W106</span></td>
                                            <td></td>
                                            <td>NAV Change:<span>$0.00</span></td>
                                        </tr>
                                        <tr>
                                            <td>Inception Date:<span>09/30/2015</span></td>
                                            <td></td>
                                            <td>Market Price:<span>$8.95</span></td>
                                        </tr>

                                        <tr>
                                            <td class="noborder"></td>
                                            <td></td>
                                            <td>Total Net Assets:<span>$168,939.60</span></td>
                                        </tr>

                                    </tbody></table>

                                <h3 class="mod1">Expenses</h3>&nbsp;
                                <date>as of <span>02/28/2023</span></date>

                                <table class="table--mod-2">

                                    <tbody><tr>
                                        <td>Direct Operating Expenses:<span>2.75%</span></td>
                                        <td></td>
                                        <td>Total Net Expense Ratio<sup>†</sup>:<span>1.77%</span></td>
                                    </tr>
                                        <tr>
                                            <td>Total Expense Ratio:<span>2.77%</span></td>
                                            <td></td>
                                            <td class="noborder"></td>
                                        </tr>

                                    </tbody></table>

                            </div>

                            <div id="dailyDataTableIndicator2" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>

                        </div>
                    }
                    {activeClass == CLASS_A &&
                        <div class="tabs__tab-content" style={{ display: "block" }}>

                            <div id="dailyDataTableWrapper3" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>

                                <h3 class="mod1">Daily Data</h3>&nbsp;
                                <date>as of <span id="daily_asofdate_a">04/11/2023</span></date>

                                <table class="table--mod-2">

                                    <tbody><tr>
                                        <td>Ticker:<span>CLOVX</span></td>
                                        <td></td>
                                        <td>NAV:<span>$9.00</span></td>
                                    </tr>
                                        <tr>
                                            <td>CUSIP:<span>18914W403</span></td>
                                            <td></td>
                                            <td>NAV Change:<span>$0.09</span></td>
                                        </tr>
                                        <tr>
                                            <td>Inception Date:<span>06/29/2018</span></td>
                                            <td></td>
                                            <td>Market Price:<span>$9.00</span></td>
                                        </tr>

                                        <tr>
                                            <td class="noborder"></td>
                                            <td></td>
                                            <td>Total Net Assets:<span>$170,615.80</span></td>
                                        </tr>

                                    </tbody></table>

                                <h3 class="mod1">Expenses</h3>&nbsp;
                                <date>as of <span>02/28/2023</span></date>

                                <table class="table--mod-2">

                                    <tbody><tr>
                                        <td>Direct Operating Expenses:<span>2.92%</span></td>
                                        <td></td>
                                        <td>Total Net Expense Ratio<sup>†</sup>:<span>1.89%</span></td>
                                    </tr>
                                        <tr>
                                            <td>Total Expense Ratio:<span>2.93%</span></td>
                                            <td></td>
                                            <td class="noborder"></td>
                                        </tr>

                                    </tbody></table>

                            </div>

                            <div id="dailyDataTableIndicator3" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>

                        </div>
                    }
                    {activeClass == CLASS_C &&
                        <div class="tabs__tab-content" style={{ display: "block" }}>

                            <div id="dailyDataTableWrapper4" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>

                                <h3 class="mod1">Daily Data</h3>&nbsp;
                                <date>as of <span id="daily_asofdate_c">02/17/2023</span></date>

                                <table class="table--mod-2">

                                    <tbody><tr>
                                        <td>Ticker:<span>CLOCX</span></td>
                                        <td></td>
                                        <td>NAV:<span>$8.45</span></td>
                                    </tr>
                                        <tr>
                                            <td>CUSIP:<span>18914W205</span></td>
                                            <td></td>
                                            <td>NAV Change:<span>$0.00</span></td>
                                        </tr>
                                        <tr>
                                            <td>Inception Date:<span>09/30/2015</span></td>
                                            <td></td>
                                            <td>Market Price:<span>$8.45</span></td>
                                        </tr>

                                        <tr>
                                            <td class="noborder"></td>
                                            <td></td>
                                            <td>Total Net Assets:<span>$228,335.10</span></td>
                                        </tr>

                                    </tbody></table>

                                <h3 class="mod1">Expenses</h3>&nbsp;
                                <date>as of <span>02/28/2023</span></date>

                                <table class="table--mod-2">

                                    <tbody><tr>
                                        <td>Direct Operating Expenses:<span>3.53%</span></td>
                                        <td></td>
                                        <td>Total Net Expense Ratio<sup>†</sup>:<span>2.53%</span></td>
                                    </tr>
                                        <tr>
                                            <td>Total Expense Ratio:<span>3.55%</span></td>
                                            <td></td>
                                            <td class="noborder"></td>
                                        </tr>

                                    </tbody></table>

                            </div>

                            <div id="dailyDataTableIndicator4" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>
                        </div>
                    }
                </div>

                <div className="spacer" />

            </div>

            <div class="container">
                <h3>Performance</h3>
                <div id="performance" class="waypoint__subnav" ref={ref2}></div>
                <div id="performanceTableWrapper">


                    <div class="tabs" id="tabs__performance">

                        <ul class="tabs__list">
                            <li class="tabs__list-item">
                                <a class={`tabs__tab ${activePerformance == ANNUALIZED ? 'active' : ''}`} onClick={() => setActivePerformance(ANNUALIZED)}>ANNUALIZED</a>
                            </li>
                            <li class="tabs__list-item">
                                <a class={`tabs__tab ${activePerformance == CUMULATIVE ? 'active' : ''}`} onClick={() => setActivePerformance(CUMULATIVE)}>CUMULATIVE</a>
                            </li>
                            <li class="tabs__list-item">
                                <a class={`tabs__tab ${activePerformance == CALENDAR_YEAR ? 'active' : ''}`} onClick={() => setActivePerformance(CALENDAR_YEAR)}>CALENDAR YEAR</a>
                            </li>
                        </ul>


                        {activePerformance == ANNUALIZED &&
                            <div class="tabs__tab-content" style={{ display: "block" }}>

                                {/* <!-- quarterly performance table --> */}

                                <div id="performanceTableWrapper_quarterly" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>


                                    <h3 class="mod1">Returns<sup> *</sup></h3>&nbsp;<date>as of 03/31/2023</date>
                                    <table id="performanceTableID_quarterly" class="table--mod-3">
                                        <tbody><tr>
                                            <th>Fund</th><th>1 Yr.</th><th>3 Yr.</th><th>5 Yr.</th><th>S.I.</th>
                                        </tr>
                                            <tr>
                                                <td>Class I (Net Asset Value)</td><td>-18.28%</td><td>1.45%</td><td>-1.47%</td><td>0.66%</td>
                                            </tr>
                                            <tr>
                                                <td>Class Inv (Net Asset Value)</td><td>-18.10%</td><td>1.33%</td><td>-1.64%</td><td>0.43%</td>
                                            </tr><tr>
                                                <td>Class A (Net Asset Value)</td><td>-18.56%</td><td>1.14%</td><td>-1.75%</td><td>0.36%</td>
                                            </tr><tr>
                                                <td>Class A (Maximum Offering Price)</td><td>-23.06%</td><td>-0.76%</td><td>-2.85%</td><td>-0.32%</td>
                                            </tr><tr>
                                                <td>Class C (Net Asset Value)</td><td>-19.06%</td><td>0.42%</td><td>-2.46%</td><td>-0.29%</td>
                                            </tr><tr>
                                                <td>Class C (Contingent Deferred Sales Charge)</td><td>-19.87%</td><td>0.42%</td><td>-2.46%</td><td>-0.29%</td>
                                            </tr><tr>
                                                <td>MSCI All Country World Index - GR (Benchmark)</td><td>-6.96%</td><td>15.90%</td><td>7.46%</td><td>8.00%</td>
                                            </tr><tr>
                                                <td>HFRI Equity Hedge (Total) Index (Benchmark)</td><td>-2.88%</td><td>12.71%</td><td>5.18%</td><td>5.28%</td>
                                            </tr></tbody>

                                    </table>

                                </div>

                                <div id="performanceTableIndicator_quarterly" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>

                            </div>
                        }
                        {activePerformance == CUMULATIVE &&
                            <div class="tabs__tab-content" style={{ display: "block" }}>

                                {/* <!-- monthly performance table --> */}

                                <div id="performanceTableWrapper_monthly" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>


                                    <h3 class="mod1">Returns<sup> *</sup></h3>&nbsp;<date>as of 01/31/2023</date>
                                    <table id="performanceTableID_monthly" class="table--mod-3">
                                        <tbody><tr>
                                            <th>Fund</th><th>1 M.</th><th>3 M.</th><th>YTD</th>
                                        </tr>
                                            <tr>
                                                <td>Class I (Net Asset Value)</td><td>1.11%</td><td>0.66%</td><td>0.66%</td>
                                            </tr>
                                            <tr>
                                                <td>Class Inv (Net Asset Value)</td><td>1.01%</td><td>0.45%</td><td>0.45%</td>
                                            </tr><tr>
                                                <td>Class A (Net Asset Value)</td><td>1.02%</td><td>0.45%</td><td>0.45%</td>
                                            </tr><tr>
                                                <td>Class A (Maximum Offering Price)</td><td>-4.50%</td><td>-5.11%</td><td>-5.11%</td>
                                            </tr><tr>
                                                <td>Class C (Net Asset Value)</td><td>0.96%</td><td>0.36%</td><td>0.36%</td>
                                            </tr><tr>
                                                <td>Class C (Contingent Deferred Sales Charge)</td><td>-0.04%</td><td>-0.64%</td><td>-0.64%</td>
                                            </tr><tr>
                                                <td>MSCI All Country World Index - GR (Benchmark)</td><td>3.15%</td><td>7.44%</td><td>7.44%</td>
                                            </tr><tr>
                                                <td>HFRI Equity Hedge (Total) Index (Benchmark)</td><td>0.89%</td><td>3.38%</td><td>3.38%</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>

                                <div id="performanceTableIndicator_monthly" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>


                            </div>
                        }
                        {activePerformance == CALENDAR_YEAR &&
                            <div class="tabs__tab-content" style={{ display: "block" }}>

                                <h3 id="yearlyPerformanceTitle" class="mod1">
                                    {/* <!--Yearly --> */}
                                    CALENDAR YEAR RETURNS <span class="asofdate"> as of 12/31/2022</span></h3>

                                <div id="tableWrapperID_yp" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>
                                    {/* <!-- scrollable --> */}
                                    {/* <!--<div id="sticky_header_WAY_yp" class="waypoint"></div>--> */}
                                    <table class="table--mod-3" id="yearlyPerformanceTable">

                                        <tr><th>Fund</th><th>2016</th><th>2017</th><th>2018</th><th>2019</th><th>2020</th><th>2021</th><th>2022</th></tr><tr><td>Class I (Net Asset Value)</td><td>-6.66%</td><td>20.02%</td><td>-10.03%</td><td>14.40%</td><td>25.03%</td><td>0.25%</td><td>-27.23%</td></tr><tr><td>Class Inv (Net Asset Value)</td><td>-6.87%</td><td>19.55%</td><td>-10.28%</td><td>14.14%</td><td>24.66%</td><td>0.02%</td><td>-27.00%</td></tr><tr><td>Class A (Net Asset Value)</td><td>-6.87%</td><td>19.55%</td><td>-10.28%</td><td>14.14%</td><td>24.57%</td><td>0.09%</td><td>-27.41%</td></tr><tr><td>Class A (Maximum Offering Price)</td><td>-11.95%</td><td>13.03%</td><td>-15.20%</td><td>7.91%</td><td>17.69%</td><td>-5.43%</td><td>-31.40%</td></tr><tr><td>Class C (Net Asset Value)</td><td>-7.54%</td><td>18.78%</td><td>-10.93%</td><td>13.29%</td><td>23.73%</td><td>-0.76%</td><td>-27.91%</td></tr><tr><td>Class C (Contingent Deferred Sales Charge)</td><td>-8.46%</td><td>17.78%</td><td>-11.82%</td><td>12.29%</td><td>22.73%</td><td>-1.61%</td><td>-28.63%</td></tr><tr><td>MSCI All-Country World Index - GR (Benchmark)</td><td>8.48%</td><td>24.62%</td><td>-8.93%</td><td>27.30%</td><td>16.82%</td><td>19.04%</td><td>-17.96%</td></tr><tr><td>HFRI Equity Hedge (Total) Index (Benchmark)</td><td>5.47%</td><td>13.29%</td><td>-6.90%</td><td>13.90%</td><td>17.49%</td><td>11.97%</td><td>-10.37%</td></tr></table>

                                </div>

                                <div id="tableIndicator_yp" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>

                            </div>
                        }
                    </div>

                </div>

                <br />



                <p class="disclosure"><b>The performance data quoted represents past performance. Past performance does not guarantee future results and current performance may be lower or higher than the performance quoted. Performance reflects the deduction of management fees and other applicable expenses. For the most current month-end performance data please call 1-855-425-6844. Investment returns and value of the fund shares will fluctuate so that an investor’s shares, when sold, may be worth more or less than their original cost.</b></p>

                <p class="disclosure">Maximum offering price (MOP) for Class A shares includes the fund’s maximum sales charge of 5.50%. Contingent deferred sales charge (CDSC) performance for Class C shares includes a 1.00% CDSC on C shares redeemed within 12 months of purchase. Performance shown at net asset value (NAV) does not include these sales charges.</p>

                <p class="disclosure">Total returns for periods greater than one year are annualized.</p>

                <p class="disclosure">* The performance data quoted for periods prior to September 30, 2015 is that of an unregistered investment fund (the “Predecessor Fund”) that was managed by Clough Capital Partners L.P. and was reorganized into the fund as of the date the fund commenced investment operations. The Predecessor Fund was not a registered mutual fund and therefore was not subject to the same investment and tax restrictions as the fund. Performance information reflects all fees and expenses incurred by the Predecessor Fund, and has not been adjusted to reflect fund expenses. If it had been so adjusted, the Predecessor Fund’s performance might have been higher or lower for a given period depending on the amount of such expenses incurred for any given period. Performance information for Class Inv and Class C have been adjusted to reflect 12b-1 fees and shareholder services fees, as applicable. The Predecessor Fund commenced operations on January 2, 2015.</p>

                <p class="disclosure">† Clough Capital Partners L.P. (the “Adviser”) has agreed contractually to limit the operating expenses of each class of the fund (excluding Rule 12b-1 Distribution and Service Fees, Shareholder Services Fees, acquired fund fees and expenses, interest, taxes, brokerage costs and commissions, dividend and interest expense on short sales, and litigation, indemnification and extraordinary expenses as determined under generally accepted accounting principles) to an annual rate of 1.25% through February 28, 2022. The following reflects the total net expense ratio excluding the dividend and interest expense on short sales &amp; acquired fund fees: Class I: 1.25%, Class Inv: 1.60%, Class A: 1.60%, Class C: 2.25%.</p>

                <p class="disclosure">As of February 28, 2019, the benchmark for the fund changed from the S&amp;P 500 Index to the MSCI All-Country World Index.</p>

                <p class="disclosure">The MSCI All Country World Index is a float-adjusted, capitalization-weighted index that is designed to measure the equity market performance of the full opportunity set of large- and mid-cap stocks across 23 developed and 24 emerging markets. Both indices referenced herein reflect the reinvestment of dividends. The MSCI information may only be used for your internal use, may not be reproduced or redisseminated in any form and may not be used as a basis for or a component of any financial instruments or products or indices. None of the MSCI information is intended to constitute investment advice or a recommendation to make (or refrain from making) any kind of investment decision and may not be relied on as such. Historical data and analysis should not be taken as an indication or guarantee of any future performance analysis, forecast or prediction. The MSCI information is provided on an “as is” basis and the user of this information assumes the entire risk of any use made of this information. MSCI, each of its affiliates and each other person involved in or related to compiling, computing or creating any MSCI information (collectively, the “MSCI Parties”) expressly disclaims all warranties (including, without limitation, any warranties of originality, accuracy, completeness, timeliness, non-infringement, merchantability and fitness for a particular purpose) with respect to this information. Without limiting any of the foregoing, in no event shall any MSCI Party have any liability for any direct, indirect, special, incidental, punitive, consequential (including, without limitation, lost profits) or any other damages (<a href="http://www.msci.com" target="_blank" class="disclosure_link_mod2">www.msci.com</a>). The HFRI Equity Hedge (Total) Index is an index designed by Hedge Fund Research, Inc. to represent the performance of investment managers who maintain positions both long and short in primarily equity and equity derivative securities. A wide variety of investment processes can be employed by such managers to arrive at an investment decision, including both quantitative and fundamental techniques; strategies can be broadly diversified or narrowly focused on specific sectors and can range broadly in terms of levels of net exposure, leverage employed, holding period, concentrations of market capitalizations and valuation ranges of typical portfolios.

                </p><p class="disclosure">The performance of the indices referenced herein is used for informational purposes only. One cannot invest directly in an index. Indices are not subject to any of the fees, allocations or expenses to which the fund are subject, and there are significant differences between the fund’s investments and the components of the indices referenced herein.</p>

                <div className="spacer" />

            </div>

            <div class="container ">
                <h3>Holdings</h3>
                <div id="holdings" class="waypoint__subnav" ref={ref3}></div>
                <br />

                <div class="tabs" id="tabs__holdings">

                    <ul class="tabs__list">
                        <li class="tabs__list-item">
                            <a class={`tabs__tab ${activeHoldings == TOP_10_HOLDINGS ? 'active' : ''}`} onClick={() => setActiveHoldings(TOP_10_HOLDINGS)}>TOP 10 EQUITY HOLDINGS</a>
                        </li>
                        <li class="tabs__list-item">
                            <a class={`tabs__tab ${activeHoldings == ALL_HOLDINGS ? 'active' : ''}`} onClick={() => setActiveHoldings(ALL_HOLDINGS)}>ALL HOLDINGS</a>
                        </li>
                    </ul>

                    {activeHoldings == TOP_10_HOLDINGS &&
                        <div class="tabs__tab-content" style={{ display: "block" }}>

                            <div id="holdingsTableWrapper_partial" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>

                                <date id="partialHoldingsAsOfDate"><br />As of 03/31/2023, subject to change</date>

                                <table class="table--mod-3 holdings" id="partial-holdings-table">
                                    <tbody><tr><th>Security</th><th>Sector</th><th>Weight</th>
                                    </tr><tr><td>Airbus SE</td><td>Industrials</td><td>4.22%</td></tr><tr><td>Northrop Grumman Corp.</td><td>Industrials</td><td>3.93%</td></tr><tr><td>The Boeing Co.</td><td>Industrials</td><td>3.47%</td></tr><tr><td>Raytheon Technologies Corp.</td><td>Industrials</td><td>2.85%</td></tr><tr><td>Royal Caribbean Cruises Ltd.</td><td>Consumer Discretionary</td><td>2.33%</td></tr><tr><td>Microsoft Corp.</td><td>Information Technology</td><td>2.23%</td></tr><tr><td>Johnson &amp; Johnson</td><td>Health Care</td><td>2.09%</td></tr><tr><td>Kinder Morgan, Inc.</td><td>Energy</td><td>1.96%</td></tr><tr><td>Home Depot, Inc.</td><td>Consumer Discretionary</td><td>1.92%</td></tr><tr><td>Crown Castle International Corp.</td><td>Real Estate</td><td>1.73%</td></tr><tr><td class="totalHoldings">Total <span>as a % of Net Assets</span></td><td></td><td>26.73%</td></tr>
                                    </tbody>
                                </table>



                            </div>

                            <div id="tableIndicator_holdings_part" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>


                            {/* <script defer="" src="assets/javascript/settings__holdings_partial_open.js"></script> */}
                        </div>
                    }
                    {activeHoldings == ALL_HOLDINGS &&
                        <div class="tabs__tab-content" style={{ display: "block" }}>

                            <div id="holdingsTableWrapper_full" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>

                                <date id="fullHoldingsAsOfDate"><br />As of 02/28/2023, subject to change</date>

                                <table id="full-holdings-table" class="table--mod-3 holdings">
                                    <tbody><tr><th>Security</th>
                                        <th>Sector</th>
                                        <th>Weight</th>
                                    </tr><tr><td>Airbus SE</td><td class="center">Industrials</td><td>4.11%</td></tr><tr><td>Northrop Grumman Corp.</td><td class="center">Industrials</td><td>3.41%</td></tr><tr><td>The Boeing Co.</td><td class="center">Industrials</td><td>3.27%</td></tr><tr><td>Raytheon Technologies Corp.</td><td class="center">Industrials</td><td>2.83%</td></tr><tr><td>Royal Caribbean Cruises Ltd.</td><td class="center">Consumer Discretionary</td><td>2.51%</td></tr><tr><td>Home Depot, Inc.</td><td class="center">Consumer Discretionary</td><td>2.45%</td></tr><tr><td>Air Canada 2013-1 Class A Pass Through Trust</td><td class="center">Fixed Income</td><td>2.33%</td></tr><tr><td>SPDR S&amp;P Biotech ETF</td><td class="center">Health Care</td><td>2.12%</td></tr><tr><td>Exxon Mobil Corp.</td><td class="center">Energy</td><td>1.99%</td></tr><tr><td>HDFC Bank, Ltd.</td><td class="center">Financials</td><td>1.98%</td></tr><tr><td>Microsoft Corp.</td><td class="center">Information Technology</td><td>1.92%</td></tr><tr><td>Kinder Morgan, Inc.</td><td class="center">Energy</td><td>1.90%</td></tr><tr><td>CRISPR Therapeutics AG</td><td class="center">Health Care</td><td>1.77%</td></tr><tr><td>Berkshire Hathaway, Inc.</td><td class="center">Financials</td><td>1.70%</td></tr><tr><td>Volkswagen Group of America Finance LLC</td><td class="center">Fixed Income</td><td>1.69%</td></tr><tr><td>T-Mobile US, Inc.</td><td class="center">Communication Services</td><td>1.68%</td></tr><tr><td>Crown Castle International Corp.</td><td class="center">Real Estate</td><td>1.68%</td></tr><tr><td>Vertex Pharmaceuticals, Inc.</td><td class="center">Health Care</td><td>1.56%</td></tr><tr><td>JDE Peet's NV</td><td class="center">Fixed Income</td><td>1.56%</td></tr><tr><td>American Tower Corp.</td><td class="center">Real Estate</td><td>1.55%</td></tr><tr><td>ICICI Bank, Ltd. - Sponsored ADR</td><td class="center">Financials</td><td>1.52%</td></tr><tr><td>TransDigm Group, Inc.</td><td class="center">Industrials</td><td>1.50%</td></tr><tr><td>BlackRock Innovation &amp; Growth Trust</td><td class="center">Closed-end Funds</td><td>1.49%</td></tr><tr><td>Johnson &amp; Johnson</td><td class="center">Health Care</td><td>1.49%</td></tr><tr><td>Jazz Pharmaceuticals PLC</td><td class="center">Health Care</td><td>1.42%</td></tr><tr><td>Tenet Healthcare Corp.</td><td class="center">Health Care</td><td>1.38%</td></tr><tr><td>Samsung Electronics Co., Ltd.</td><td class="center">Information Technology</td><td>1.35%</td></tr><tr><td>Starwood Property Trust, Inc.</td><td class="center">Financials</td><td>1.33%</td></tr><tr><td>Boston Scientific Corp.</td><td class="center">Health Care</td><td>1.33%</td></tr><tr><td>Illumina, Inc.</td><td class="center">Health Care</td><td>1.29%</td></tr><tr><td>Taiwan Semiconductor Manufacturing Co., Ltd.</td><td class="center">Information Technology</td><td>1.28%</td></tr><tr><td>UnitedHealth Group, Inc.</td><td class="center">Health Care</td><td>1.27%</td></tr><tr><td>Bank of America Corp.</td><td class="center">Financials</td><td>1.17%</td></tr><tr><td>Palo Alto Networks, Inc.</td><td class="center">Information Technology</td><td>1.13%</td></tr><tr><td>Legend Biotech Corp.</td><td class="center">Health Care</td><td>1.12%</td></tr><tr><td>Acadia Healthcare Co., Inc.</td><td class="center">Health Care</td><td>1.08%</td></tr><tr><td>Alphabet, Inc.</td><td class="center">Communication Services</td><td>1.05%</td></tr><tr><td>Amazon.com, Inc.</td><td class="center">Consumer Discretionary</td><td>1.04%</td></tr><tr><td>iShares MSCI China ETF</td><td class="center">ETF-Index</td><td>1.02%</td></tr><tr><td>Redwood Trust, Inc.</td><td class="center">Fixed Income</td><td>1.02%</td></tr><tr><td>Amedisys, Inc.</td><td class="center">Health Care</td><td>1.01%</td></tr><tr><td>Cheniere Energy, Inc.</td><td class="center">Energy</td><td>0.98%</td></tr><tr><td>TransDigm, Inc.</td><td class="center">Fixed Income</td><td>0.98%</td></tr><tr><td>Tesla, Inc.</td><td class="center">Consumer Discretionary</td><td>0.94%</td></tr><tr><td>Schlumberger, Ltd.</td><td class="center">Energy</td><td>0.88%</td></tr><tr><td>Lam Research Corp.</td><td class="center">Information Technology</td><td>0.87%</td></tr><tr><td>Lululemon Athletica, Inc.</td><td class="center">Consumer Discretionary</td><td>0.87%</td></tr><tr><td>Melco Resorts &amp; Entertainment, Ltd.</td><td class="center">Consumer Discretionary</td><td>0.80%</td></tr><tr><td>Veracyte, Inc.</td><td class="center">Health Care</td><td>0.78%</td></tr><tr><td>Surgery Partners, Inc.</td><td class="center">Health Care</td><td>0.76%</td></tr><tr><td>Blackstone Mortgage Trust, Inc.</td><td class="center">Financials</td><td>0.74%</td></tr><tr><td>Norwegian Cruise Line Holdings, Ltd.</td><td class="center">Consumer Discretionary</td><td>0.73%</td></tr><tr><td>S&amp;P 500 INDEX-SPX US 04/21/23 P3850</td><td class="center">Hedges</td><td>0.70%</td></tr><tr><td>BYD Co., Ltd.</td><td class="center">Consumer Discretionary</td><td>0.69%</td></tr><tr><td>Blackrock Capital Allocation Trust</td><td class="center">Closed-end Funds</td><td>0.65%</td></tr><tr><td>Visa, Inc.</td><td class="center">Information Technology</td><td>0.64%</td></tr><tr><td>Jabil, Inc.</td><td class="center">Information Technology</td><td>0.64%</td></tr><tr><td>MainStay CBRE Global Infrastructure Megatrends Fund</td><td class="center">Closed-end Funds</td><td>0.62%</td></tr><tr><td>Wynn Resorts, Ltd.</td><td class="center">Consumer Discretionary</td><td>0.60%</td></tr><tr><td>Golub Capital BDC, Inc.</td><td class="center">Financials</td><td>0.60%</td></tr><tr><td>Marvell Technology Group, Ltd.</td><td class="center">Information Technology</td><td>0.56%</td></tr><tr><td>Hologic, Inc.</td><td class="center">Health Care</td><td>0.54%</td></tr><tr><td>Hertz Global Holdings, Inc.</td><td class="center">Industrials</td><td>0.53%</td></tr><tr><td>Merck &amp; Co., Inc.</td><td class="center">Health Care</td><td>0.52%</td></tr><tr><td>Blackstone Secured Lending Fund</td><td class="center">Financials</td><td>0.51%</td></tr><tr><td>Select Medical Holdings Corp.</td><td class="center">Health Care</td><td>0.51%</td></tr><tr><td>Encompass Health Corp.</td><td class="center">Health Care</td><td>0.50%</td></tr><tr><td>US Airways 2013-1 Class A Pass Through Trust</td><td class="center">Fixed Income</td><td>0.46%</td></tr><tr><td>Hertz Global Holdings, Inc.</td><td class="center">Industrials</td><td>0.45%</td></tr><tr><td>S&amp;P 500 INDEX-SPX US 03/17/23 P3850</td><td class="center">Hedges</td><td>0.39%</td></tr><tr><td>Arcellx, Inc.</td><td class="center">Health Care</td><td>0.39%</td></tr><tr><td>Enhabit, Inc.</td><td class="center">Health Care</td><td>0.33%</td></tr><tr><td>2seventy bio, Inc.</td><td class="center">Health Care</td><td>0.26%</td></tr><tr><td>Novo Nordisk A/S</td><td class="center">Health Care</td><td>0.26%</td></tr><tr><td>United States Natural Gas Fund LP</td><td class="center">Energy</td><td>0.22%</td></tr><tr><td>S&amp;P 500 INDEX-SPX US 03/17/23 P3800</td><td class="center">Hedges</td><td>0.04%</td></tr><tr><td>S&amp;P 500 INDEX-SPX US 03/17/23 P3450</td><td class="center">Hedges</td><td>0.00%</td></tr><tr><td>S&amp;P 500 INDEX-SPX US 03/17/23 P3650</td><td class="center">Hedges</td><td>-0.07%</td></tr><tr><td>Toast, Inc.</td><td class="center">Information Technology</td><td>-0.09%</td></tr><tr><td>Shopify, Inc.</td><td class="center">Information Technology</td><td>-0.11%</td></tr><tr><td>Societe Generale S.A.</td><td class="center">Financials</td><td>-0.14%</td></tr><tr><td>Intesa Sanpaolo SpA</td><td class="center">Financials</td><td>-0.16%</td></tr><tr><td>S&amp;P 500 Emini Future</td><td class="center">Hedges</td><td>-0.16%</td></tr><tr><td>BANCO BILBAO VIZCAYA ARGENTARIA SA TRS</td><td class="center">Financials</td><td>-0.17%</td></tr><tr><td>Elastic NV</td><td class="center">Information Technology</td><td>-0.17%</td></tr><tr><td>Palantir Technologies, Inc.</td><td class="center">Information Technology</td><td>-0.19%</td></tr><tr><td>GLOBALFOUNDRIES, Inc.</td><td class="center">Information Technology</td><td>-0.19%</td></tr><tr><td>UniCredit SpA</td><td class="center">Financials</td><td>-0.20%</td></tr><tr><td>ON Semiconductor Corp.</td><td class="center">Information Technology</td><td>-0.20%</td></tr><tr><td>3 MONTH SOFR FUT  Dec23</td><td class="center">Hedges</td><td>-0.21%</td></tr><tr><td>UiPath, Inc.</td><td class="center">Information Technology</td><td>-0.21%</td></tr><tr><td>HubSpot, Inc.</td><td class="center">Information Technology</td><td>-0.26%</td></tr><tr><td>S&amp;P 500 INDEX-SPX US 04/21/23 P3650</td><td class="center">Hedges</td><td>-0.28%</td></tr><tr><td>Credit Agricole S.A.</td><td class="center">Financials</td><td>-0.29%</td></tr><tr><td>Smartsheet, Inc.</td><td class="center">Information Technology</td><td>-0.29%</td></tr><tr><td>BNP Paribas S.A.</td><td class="center">Financials</td><td>-0.32%</td></tr><tr><td>Softbank Group Corp.</td><td class="center">Communication Services</td><td>-0.43%</td></tr><tr><td>Deutsche Bank AG</td><td class="center">Financials</td><td>-0.54%</td></tr><tr><td>Eurodollar 90 Day</td><td class="center">Hedges</td><td>-0.55%</td></tr><tr><td>Sociedad Quimica Y Minera De Chile SA</td><td class="center">Materials</td><td>-0.55%</td></tr><tr><td>Ford Motor Co.</td><td class="center">Consumer Discretionary</td><td>-0.61%</td></tr><tr><td>Macy's, Inc.</td><td class="center">Consumer Discretionary</td><td>-0.67%</td></tr><tr><td>Asbury Automotive Group, Inc.</td><td class="center">Consumer Discretionary</td><td>-0.75%</td></tr><tr><td>Autonation Inc</td><td class="center">Consumer Discretionary</td><td>-0.75%</td></tr><tr><td>Biogen, Inc.</td><td class="center">Health Care</td><td>-0.78%</td></tr><tr><td>International Business Machines Corp.</td><td class="center">Information Technology</td><td>-1.10%</td></tr><tr><td>Harley-Davidson, Inc.</td><td class="center">Consumer Discretionary</td><td>-1.58%</td></tr><tr><td>BlackRock Liquidity Funds, T-Fund Portfolio - Institutional Class</td><td class="center">Money Market Fund</td><td>7.09%</td></tr></tbody>
                                </table>

                            </div>

                            <div id="tableIndicator_holdings_full" class="tableOverflowIndicatorMobile">
                                ← Swipe to see additional data →
                            </div>
                        </div>
                    }
                </div>


                <p class="disclosure">Holdings subject to change without notice.</p>
                <div className="spacer" />

            </div>



            <div class="container ">
                <h3>Distributions</h3>
                <div id="distributions" class="waypoint__subnav" ref={ref4}></div>
                <div class="tabs" id="tabs__distributions">

                    <ul class="tabs__list">
                        <li class="tabs__list-item">
                            <a class={`tabs__tab ${activeDistribution == CURRENT_YEAR ? 'active' : ''}  tab_override`} onClick={() => setActiveDistribution(CURRENT_YEAR)}>Current Year</a>
                        </li>
                        <li class="tabs__list-item">
                            <a class={`tabs__tab ${activeDistribution == PREVIOUS_YEAR ? 'active' : ''}  tab_override`} onClick={() => setActiveDistribution(PREVIOUS_YEAR)}>Previous Years</a>
                        </li>

                    </ul>

                    <div class="distributions-wrapper">




                        <div id="distributionsTableWrapper" class="tableHorizontalScroll" style={{ overflowX: "hidden" }}>
                            {activeDistribution == CURRENT_YEAR &&
                                <table id="table__distributions" class="table--reduced-padding distributions-table" style={{ display: "table" }}>
                                    <tbody><tr>
                                        <th style={{ border: "none" }}>Class</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Ex-Date</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Record Date</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Payable Date</th>
                                        <th style={{ textAlign: "center", border: "none" }}>STCG</th>
                                        <th style={{ textAlign: "center", border: "none" }}>LTCG</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Income</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Total</th>
                                    </tr>
                                        <tr class="odd-row" style={{ height: "52.4px", padding: "0px", margin: "0px", width: "1190px" }}>
                                            <td colspan="8" style={{ textAlign: "center" }}>No Distributions for the Current Year</td></tr>
                                    </tbody></table>
                            }
                            {activeDistribution == PREVIOUS_YEAR &&
                                <table id="table__distributions" class="table--reduced-padding distributions-table" style={{ display: "table" }}>
                                    <tbody><tr>
                                        <th style={{ border: "none" }}>Class</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Ex-Date</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Record Date</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Payable Date</th>
                                        <th style={{ textAlign: "center", border: "none" }}>STCG</th>
                                        <th style={{ textAlign: "center", border: "none" }}>LTCG</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Income</th>
                                        <th style={{ textAlign: "center", border: "none" }}>Total</th>
                                    </tr>


                                        <tr class="odd-row" style={{ height: "52.4px", padding: "0px", margin: "0px", width: "1190px", opacity: "1" }}>
                                            <td>CLOIX</td>
                                            <td>12/15/2022</td>
                                            <td>12/14/2022</td>
                                            <td>12/16/2022</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOAX</td>
                                            <td>12/15/2022</td>
                                            <td>12/14/2022</td>
                                            <td>12/16/2022</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr class="odd-row" style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOVX</td>
                                            <td>12/15/2022</td>
                                            <td>12/14/2022</td>
                                            <td>12/16/2022</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOCX</td>
                                            <td>12/15/2022</td>
                                            <td>12/14/2022</td>
                                            <td>12/16/2022</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOIX</td>
                                            <td>12/16/2021</td>
                                            <td>12/15/2021</td>
                                            <td>12/17/2021</td>
                                            <td>$0.30157</td>
                                            <td>$1.34035</td>
                                            <td>$0.34671</td>
                                            <td>$1.98863</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOAX</td>
                                            <td>12/16/2021</td>
                                            <td>12/15/2021</td>
                                            <td>12/17/2021</td>
                                            <td>$0.30157</td>
                                            <td>$1.34035</td>
                                            <td>$0.33475</td>
                                            <td>$1.97667</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOVX</td>
                                            <td>12/16/2021</td>
                                            <td>12/15/2021</td>
                                            <td>12/17/2021</td>
                                            <td>$0.30157</td>
                                            <td>$1.34035</td>
                                            <td>$0.33479</td>
                                            <td>$1.97671</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOCX</td>
                                            <td>12/16/2021</td>
                                            <td>12/15/2021</td>
                                            <td>12/17/2021</td>
                                            <td>$0.30157</td>
                                            <td>$1.34035</td>
                                            <td>$0.31910</td>
                                            <td>$1.96102</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOIX</td>
                                            <td>12/17/2020</td>
                                            <td>12/16/2020</td>
                                            <td>12/18/2020</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>$0.06273</td>
                                            <td>$0.06273</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOAX</td>
                                            <td>12/17/2020</td>
                                            <td>12/16/2020</td>
                                            <td>12/18/2020</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>$0.05534</td>
                                            <td>$0.05534</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOVX</td>
                                            <td>12/17/2020</td>
                                            <td>12/16/2020</td>
                                            <td>12/18/2020</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>$0.05507</td>
                                            <td>$0.05507</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOCX</td>
                                            <td>12/17/2020</td>
                                            <td>12/16/2020</td>
                                            <td>12/18/2020</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>$0.04072</td>
                                            <td>$0.04072</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOIX</td>
                                            <td>12/18/2019</td>
                                            <td>12/17/2019</td>
                                            <td>12/19/2019</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOAX</td>
                                            <td>12/18/2019</td>
                                            <td>12/17/2019</td>
                                            <td>12/19/2019</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOVX</td>
                                            <td>12/18/2019</td>
                                            <td>12/17/2019</td>
                                            <td>12/19/2019</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOCX</td>
                                            <td>12/18/2019</td>
                                            <td>12/17/2019</td>
                                            <td>12/19/2019</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOIX</td>
                                            <td>12/19/2018</td>
                                            <td>12/18/2018</td>
                                            <td>12/20/2018</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOAX</td>
                                            <td>12/19/2018</td>
                                            <td>12/18/2018</td>
                                            <td>12/20/2018</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOVX</td>
                                            <td>12/19/2018</td>
                                            <td>12/18/2018</td>
                                            <td>12/20/2018</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOCX</td>
                                            <td>12/19/2018</td>
                                            <td>12/18/2018</td>
                                            <td>12/20/2018</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOIX</td>
                                            <td>12/20/2017</td>
                                            <td>12/19/2017</td>
                                            <td>12/21/2017</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOAX</td>
                                            <td>12/20/2017</td>
                                            <td>12/19/2017</td>
                                            <td>12/21/2017</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOCX</td>
                                            <td>12/20/2017</td>
                                            <td>12/19/2017</td>
                                            <td>12/21/2017</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOIX</td>
                                            <td>12/21/2016</td>
                                            <td>12/20/2016</td>
                                            <td>12/22/2016</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOAX</td>
                                            <td>12/21/2016</td>
                                            <td>12/20/2016</td>
                                            <td>12/22/2016</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOCX</td>
                                            <td>12/21/2016</td>
                                            <td>12/20/2016</td>
                                            <td>12/22/2016</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOIX</td>
                                            <td>12/21/2015</td>
                                            <td>12/18/2015</td>
                                            <td>12/22/2015</td>
                                            <td>$0.03715</td>
                                            <td>$0.00142</td>
                                            <td>-</td>
                                            <td>$0.03857</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOAX</td>
                                            <td>12/21/2015</td>
                                            <td>12/18/2015</td>
                                            <td>12/22/2015</td>
                                            <td>$0.03715</td>
                                            <td>$0.00142</td>
                                            <td>-</td>
                                            <td>$0.03857</td>
                                        </tr><tr style={{ height: "52.4px", width: "1190px", opacity: "1" }}>
                                            <td>CLOCX</td>
                                            <td>12/21/2015</td>
                                            <td>12/18/2015</td>
                                            <td>12/22/2015</td>
                                            <td>$0.03715</td>
                                            <td>$0.00142</td>
                                            <td>-</td>
                                            <td>$0.03857</td>
                                        </tr></tbody>
                                </table>
                            }
                        </div>

                        <div id="distributionsTableIndicator" class="tableOverflowIndicatorMobile">← Swipe to see additional data →</div>

                        <div class="nodistributions" style={{ display: "none" }}>Distributions data is unavailable at this time.</div>

                    </div>
                </div>

                <div className="spacer" />

            </div>


            <div class="container">
                <h3>Resources</h3>
                <div id="resources" class="waypoint__subnav" ref={ref5}></div>
                <h3 class="mod2 underline">Current Updates</h3>

                <table class="table--mod-1 table_alt1">
                    <tbody><tr>
                        <td><b>Document</b></td>
                        <td><b>Date</b></td>
                        <td><b>Download</b></td>
                    </tr>
                        {currentList?.length > 0 && currentList.map((data, idx) => {
                            return (
                                <tr key={idx}>
                                    <td>{data?.friendlyName}</td>
                                    <td>{data.createdAt ? moment(data.createdAt).format("MM/DD/yyyy") : '-'}</td>
                                    <td>
                                        <a href={`${process.env.REACT_APP_API_LINK}download_resource/?id=${data?.id}&ticker=${data?.ticker}`} target="_blank" style={{}}>
                                            <img src={downloadIcon} width="22" height="22" alt="Download Section 19a PDF" title="Download" />
                                        </a>
                                    </td>

                                </tr>
                            )
                        })}
                    </tbody></table>

                <br />

                <h3 class="mod2 underline">PROSPECTUS &amp; REPORTS</h3>

                <table class="table--mod-1 table_alt1">
                    <tbody><tr>
                        <td><b>Document</b></td>
                        <td><b>Date</b></td>
                        <td><b>Download</b></td>
                    </tr>
                        {reportList?.length > 0 && reportList.map((data, idx) => {
                            return (
                                <tr key={idx}>
                                    <td>{data?.friendlyName}</td>
                                    <td>{data.createdAt ? moment(data.createdAt).format("MM/DD/yyyy") : '-'}</td>
                                    <td>
                                        <a href={`${process.env.REACT_APP_API_LINK}download_resource/?id=${data?.id}&ticker=${data?.ticker}`} target="_blank" style={{}}>
                                            <img src={downloadIcon} width="22" height="22" alt="Download Section 19a PDF" title="Download" />
                                        </a>
                                    </td>

                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                <br />


            </div>

            <div className="spacer" />
            <div className="spacer" />

        </>
    );
}

export default LongShortFund;